'use strict';var _dec,_desc,_value,_class;function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const BaseController=require('../../../../../../../dist-es6/client/angularCommon/baseController');
const HandleUncaughtErrors=require('../../../../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const ModalSubmissionResult=require('../../../../../../../dist-es6/client/angularCommon/modalSubmissionResult');
const SocketResponse=require('../../../../../../../dist-es6/client/dtos/socketResponse');
const timespan=require('pulsar-utils/dist-es6/time/timespan');

const DayInMilliseconds=timespan.fromDays(1).totalMilliseconds();let
AddDoNotDisturbScheduleModalController=(_dec=



























HandleUncaughtErrors(ModalSubmissionResult.FromError),(_class=class AddDoNotDisturbScheduleModalController extends BaseController{static get $inject(){return['$modalInstance','socketService','$scope','$timeout','uiCommandFactory','onScheduleAdded','timeZoneService','notificationService','uncaughtErrorHandler']}constructor($modalInstance,socketService,$scope,$timeout,uiCommandFactory,onScheduleAdded,timeZoneService,notificationService,uncaughtErrorHandler){super(uncaughtErrorHandler);this._socketService=socketService;this._$modalInstance=$modalInstance;this._onScheduleAdded=onScheduleAdded;this._$timeout=$timeout;this._$scope=$scope;this._addScheduleCommand=uiCommandFactory.makeForModal($modalInstance,this._addSchedule.bind(this));this._daysOfWeek=moment.weekdays().map(day=>({day:day.substr(0,3)}));this._selectedDaysOfWeek=[];this._timeZone=timeZoneService.localTimeZone;this._timeZoneService=timeZoneService;this._notificationService=notificationService;this._isPaused=!1;this.isAllDay=!0;$scope.$watch('controller.selectedDaysOfWeek',()=>{this._resetSubmissionErrors()})}
async _addSchedule(){
this._resetSubmissionErrors();

if(this._formIsInvalid()){
return ModalSubmissionResult.KeepOpen;
}

let addScheduleRequestJSON={
startTimeOfDay:this.isAllDay?0:this._startTimeMsSinceMidnight,
endTimeOfDay:this.isAllDay?0:this._endTimeMsSinceMidnight,
daysOfWeek:this._daysOfWeek.map(day=>_.includes(this._selectedDaysOfWeek,day)),
timeZone:this._timeZone,
isPaused:this._isPaused};


let addResult=await this._socketService.sendAndWaitForResponse('AddDoNotDisturbSchedule',addScheduleRequestJSON);



await this._onScheduleAdded(addResult);

return ModalSubmissionResult.Close();
}

_formIsInvalid(){
let hasError=!1;

if(this._selectedDaysOfWeek.length===0){
this._$timeout(()=>this.showSelectedDaysError=!0);
hasError=!0;
}

if(!this.isAllDay){
if(this.form['start-time'].$invalid||this.form['end-time'].$invalid){
hasError=!0;
}


if(this._startTimeMsSinceMidnight<0||this.startTimeMsSinceMidnight>DayInMilliseconds){
hasError=!0;
}
if(this._endTimeMsSinceMidnight<0||this.endTimeMsSinceMidnight>DayInMilliseconds){
hasError=!0;
}
}

return hasError;
}

dayOfWeekFormatter(value){
return value.day;
}

onCancel(){
this._$modalInstance.dismiss();
}

_resetSubmissionErrors(){
this._$timeout(()=>this.showSelectedDaysError=!1);
}

get addScheduleCommand(){
return this._addScheduleCommand;
}

get USIanaTimeZones(){
return this._timeZoneService.USIanaTimeZones;
}

get form(){
return this._form;
}

set form(form){
this._form=form;
}

get startTimeMsSinceMidnight(){
return this._startTimeMsSinceMidnight;
}

set startTimeMsSinceMidnight(startTimeMsSinceMidnight){
this._startTimeMsSinceMidnight=startTimeMsSinceMidnight;
}

get endTimeMsSinceMidnight(){
return this._endTimeMsSinceMidnight;
}

set endTimeMsSinceMidnight(endTimeMsSinceMidnight){
this._endTimeMsSinceMidnight=endTimeMsSinceMidnight;
}

get selectedDaysOfWeek(){
return this._selectedDaysOfWeek;
}

set selectedDaysOfWeek(selectedDaysOfWeek){
this._selectedDaysOfWeek=selectedDaysOfWeek;
}

get daysOfWeek(){
return this._daysOfWeek;
}

set daysOfWeek(daysOfWeek){
this._daysOfWeek=daysOfWeek;
}

get timeZone(){
return this._timeZone;
}

set timeZone(timeZone){
this._timeZone=timeZone;
}},(_applyDecoratedDescriptor(_class.prototype,'_addSchedule',[_dec],Object.getOwnPropertyDescriptor(_class.prototype,'_addSchedule'),_class.prototype)),_class));


module.exports=AddDoNotDisturbScheduleModalController;
//# sourceMappingURL=addDoNotDisturbScheduleModalController.js.map
